import Panel from '../components/panel.tsx'
import {Button} from '../components/button.tsx'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { ModalClose } from '../components/modal-close.tsx';


export default function ModalInfoEnergieverbrauch() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1 id="modal-title">Energieverbrauch</h1>
            <p id="modal-description">Der bisherige und der neue Energieverbrauch werden zur besseren Vergleichbarkeit in der Einheit Ihrer bisherigen Heizung angezeigt.</p>
            <ModalClose label={"weiter"} onClick={()=>{
                            pop_modal();
                        }}/>
         </Panel>)
}

